/* RESPONSIBLE TEAM: team-automation-foundations */
import Model, { attr } from '@ember-data/model';

export default class Cluster extends Model {
  @attr('string') text;
  @attr('date') conversationCreatedAt;
  @attr('number') similarityToArchetype;
}
